import React, { useState } from 'react';
import { toastr }          from 'react-redux-toastr'
import * as pApi           from 'pursuit/api/pursuitApi';

export default function PursuitMovement() {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [buttonEnabled, setButtonEnabled] = useState(true);

    let emailInput = null;
    let firstNameInput = null;
    let lastNameInput = null;

    const doKeyDown = (event) => {
        if (buttonEnabled === false) {
            return;
        }

        if (event.keyCode === 13) {
            doSubmit();
        }
    };

    const doSubmit = () => {
        if (buttonEnabled === false) {
            return;
        }

        if (email == '') {
            toastr.warning(
                'Oops!',
                'Before we can collect your email for the FREE Pursuit Movement classes, you have to enter one.'
            );

            emailInput.focus();

            return false;
        }
        if (firstName == '') {
            toastr.warning(
                'Oops!',
                'Before we can collect your email for the FREE Pursuit Movement classes, you have to enter your First Name.'
            );

            firstNameInput.focus();

            return false;
        }
        if (lastName == '') {
            toastr.warning(
                'Oops!',
                'Before we can collect your email for the FREE Pursuit Movement classes, you have to enter your Last Name.'
            );

            lastNameInput.focus();

            return false;
        }

        if (pApi.validEmail(email) === false) {
            toastr.warning(
                'Oops!',
                'The entered email address doesn\'t appear to be valid.'
            );

            emailInput.focus();

            return false;
        }

        setButtonEnabled(false);

        pApi.submitMovementSignup({
            email: email,
            firstName: firstName,
            lastName: lastName,
        })
            .then(() => {
                setButtonEnabled(true);
            });
    };

    const buttonClass = buttonEnabled === true ?
        '' :
        ' disabled';

    return (
        <section role="main" className="pursuit-movement">
            <div>
                <div className="justify-center minor-margin--bottom">
                    <img src="/img/branding/logo_pursuitMovement.webp" />
                </div>

                <div className="grid-center">
                    <div className="col-6_xs-11">
                        <p>Hi Pursuit Team!</p>

                        <p>We are developing an exciting new online platform to keep you active at home! For the next TWO weeks our LIVE classes will be FREE, we hope you can join us and move with us. Please leave your email address below to receive an email with our LIVE schedule and description of classes we will be offering.</p>

                        <ul className="styled">
                            <li>We will be offering an online platform of archived classes, bonus themed therapeutic movement sessions and meditation, and new LIVE classes each week AFTER the two-week trial. ALL feedback is welcome to help us develop Pursuit Movement into something great, please let us know if you have specific classes and times that you are interested in.</li>
                        </ul>

                        <div className="justify-center minor-margin--bottom major-margin--top">
                            <input type="email"
                                placeholder="Email Address"
                                onChange={event => setEmail(event.target.value)}
                                onKeyDown={doKeyDown}
                                ref={input => emailInput = input}
                            />
                        </div>
                        <div className="justify-center">
                            <input type="text"
                                className="minor-margin--bottom"
                                placeholder="First Name"
                                onChange={event => setFirstName(event.target.value)}
                                onKeyDown={doKeyDown}
                                ref={input => firstNameInput = input}
                            />
                            <input type="text"
                                className="minor-margin--bottom"
                                placeholder="Last Name"
                                onChange={event => setLastName(event.target.value)}
                                onKeyDown={doKeyDown}
                                ref={input => lastNameInput = input}
                            />
                        </div>

                        <div className="justify-center major-margin--bottom">
                            <div
                                className={"button"+buttonClass}
                                onClick={doSubmit}
                            >
                                Subscribe
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
